import ModelTypeConstants from 'constants/ModelTypeConstants';

import {TemplateCollectionGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionGraphQL';

/**
 * @package
 */
export function getNumTemplatesOfType(
  templateCollection: TemplateCollectionGraphQL,
  modelType: ModelTypeConstants
): number {
  return templateCollection.counts[modelType] ?? 0;
}

/**
 * @package
 */
export function doesTemplateCollectionIncludeProcedures(
  templateCollection: TemplateCollectionGraphQL
): boolean {
  return (
    getNumTemplatesOfType(templateCollection, ModelTypeConstants.RECIPE_PROCEDURE) +
      getNumTemplatesOfType(templateCollection, ModelTypeConstants.ASSAY_PROCEDURE) >
    0
  );
}
